import CardActionArea from '@material-ui/core/CardActionArea';
import styled from 'styled-components';

export const CardBase = styled(CardActionArea)`
  &.MuiCardActionArea-root {
    width: 100%;
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: row;
    background: #fff;
    position: relative;
    border: 1px solid ${props => props.theme.onBackground};
    transition: all 0.3s ease-in-out;
    padding: 1rem 1rem;
    color: ${props => props.theme.textColor};
    border-radius: 4px;

    h3 {
      text-transform: uppercase;
      margin-bottom: 0.5rem;
    }
    span {
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: bold;
    }

    figure {
      display: flex;
      background-color: #fff;
      align-items: center;
      justify-content: center;
      width: 6.5rem;
      padding: 0.9rem;
      border: 1px solid ${props => props.theme.primaryColor};
      border-radius: 4px;
      position: relative;
      top: -45px;
      z-index: 1;
      transition: all 0.3s ease-in-out;
    }

    div {
      display: flex;
      flex-direction: column;

      &.main-card {
        width: 100%;
      }
    }

    section {
      display: flex;
      flex-direction: column;
      margin-left: 1rem;
    }

    footer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 2rem;
      color: ${props => props.theme.primaryColor};

      svg {
        width: 24px;
      }

      &:hover {
        transition: all 0.3s ease-in-out;
        color: ${props => props.theme.secondaryColor};
      }
    }

    &:hover {
      transition: all 0.3s ease-in-out;
      border: 1px solid ${props => props.theme.secondaryColor};

      figure {
        border: 1px solid ${props => props.theme.secondaryColor};
      }
    }
  }
`;
